import axios, { extractData } from '@atheneum/api'
import flatten from 'lodash/flatten'
import { computed, extendObservable } from 'mobx'

class DeliverableStore {
  constructor () {
    extendObservable(this, {
      id: null,
      deliverables: [],
      loading: false,
      error: null,
      statistics: null,
      unallocatedFees: computed(() => this.getUnallocatedFees())
    })
  }

  get (id) {
    this.loading = true
    return axios
      .get('/api/project/' + id + '/deliverables')
      .then(res => {
        this.deliverables.replace(extractData(res))
        this.id = id
        this.getStatistics(id)
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getByProject (projectId, { paygOnly = false } = {}) {
    this.loading = true

    return axios
      .get(`/api/project/${projectId}/deliverables?paygOnly=${paygOnly}`)
      .then(res => {
        this.deliverables.replace(extractData(res))
        this.id = projectId
        this.getStatistics(projectId)
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getByContract (contractId) {
    this.loading = true
    return axios
      .get('/api/contract/' + contractId + '/deliverables')
      .then(res => {
        this.deliverables.replace(extractData(res))
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getStatistics (projectId) {
    this.loading = true
    return axios
      .get('/api/project/' + projectId + '/statistics')
      .then(res => {
        this.statistics = extractData(res)
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getUnallocatedFees () {
    if (!this.deliverables) return []

    const feesAndCostGroups = this.deliverables.map(deliverable => {
      return deliverable.fees.map(fee => {
        return {
          ...fee,
          parentName: deliverable.name
        }
      })
    })

    const feesAndCosts = flatten(feesAndCostGroups)
    const unallocatedFees = feesAndCosts.filter(feeOrCost =>
      this.isUnallocatedFee(feeOrCost)
    )

    return unallocatedFees
  }

  getFeeItem (fee) {
    const feeItem = fee.feeItems.find(item => item.feeTypeId)
    return feeItem
  }

  isFee (fee) {
    return this.getFeeItem(fee)
  }

  isUnallocatedFee (fee) {
    return !fee.invoiceId && this.isFee(fee)
  }
}

export default DeliverableStore
